import React from 'react';
import PropTypes from 'prop-types';
import { EnergySymbol } from '../Energy';

/**
 * A sentence of the log as describeEntry writes it: an energy type written {fire} shows as its symbol, the way the
 * cards print them, and a card or attack name written **Machop** shows bold.
 */
const LogText = ({ text }) => (
  <span>
    {text.split(/(\{[a-z]+\}|\*\*[^*]+\*\*)/).map((part, i) => {
      if (/^\{[a-z]+\}$/.test(part)) {
        return <EnergySymbol key={i} type={part.slice(1, -1)} size="1.1em" />;
      }
      if (/^\*\*[^*]+\*\*$/.test(part)) {
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      }
      return part;
    })}
  </span>
);

LogText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default LogText;
